package nl.astraeus.wiki.messages

class PageMessage() : Message(
  MessageType.PAGE_MESSAGE,
  MessageHeader.WIKI_ID,
  MessageHeader.PAGE_ID,
  MessageHeader.PAGE_TITLE,
) {

  constructor(msg: String) : this() {
    this.message = msg
  }

  constructor(
    messageId: String,
    wikiId: Long,
    id: Long,
    title: String,
    content: String
  ) : this() {
    setHeader(MessageHeader.MESSAGE_ID, messageId)
    setHeader(MessageHeader.WIKI_ID, wikiId.toString())
    setHeader(MessageHeader.PAGE_ID, id.toString())
    setHeader(MessageHeader.PAGE_TITLE, title)
    setBody(content)
  }

}
